import { useSearchFilters } from '@/hooks/useSearchFilters';
import { SearchPageObjectModel } from '@/poms/searchPageObjectModel';
import { Box, styled } from '@mui/material';
import { MatchTypeSelection } from './MatchTypeSelection';
import { SearchInputSection } from './SearchInputSection';
import { ThresholdSliderSection } from './ThresholdSliderSection';

const SearchControlsContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  height: '100%',
  overflowY: 'auto',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const SearchControls = () => {
  const { selectedFilters, isAssetSearch, searchType, updateSearchQuery, searchQuery } = useSearchFilters();

  return (
    <SearchControlsContainer sx={{ marginLeft: '6px', marginRight: '6px', width: '250px', flexShrink: 0 }}>
      <SearchInputSection searchQuery={searchQuery} onSearch={updateSearchQuery} />
      {isAssetSearch && <MatchTypeSelection selectedFilters={selectedFilters} />}
      {['geometric', 'part'].includes(searchType) && (
        <ThresholdSliderSection label='Match Threshold' testId={SearchPageObjectModel.MatchToleranceSection} />
      )}
      {['visual'].includes(searchType) && (
        <ThresholdSliderSection label='Size Threshold' testId={SearchPageObjectModel.SizeThresholdSection} />
      )}
    </SearchControlsContainer>
  );
};
